import React, { Ref } from 'react'
import { Field, FieldProps } from 'formik'
import { TextInput } from '@pandiafi/design-system'

import FormFieldWrapper from 'components/FormField'

interface FormikTextFieldProps {
  name: string
  label: string
  required?: boolean
  className?: string
  placeholder?: string
  inputRef?: Ref<HTMLInputElement>
  maxLength?: number
}

export const FormTextField: React.FC<FormikTextFieldProps> = ({
  name,
  label,
  required = false,
  className,
  placeholder,
  inputRef,
  maxLength,
}) => {
  return (
    <Field name={name}>
      {({ field, meta }: FieldProps<string>) => (
        <FormFieldWrapper
          name={name}
          label={label}
          required={required}
          className={className}
          meta={meta}
          labelBold
        >
          <TextInput
            {...field}
            placeholder={placeholder}
            id={name}
            ref={inputRef}
            maxLength={maxLength}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
